import jsPDF from 'jspdf'
import AnalyticsRelatory from './components/AnalyticsRelatory'
import ReactDOM from 'react-dom'
import { OperationModel } from 'interfaces/operation'
import { axiosWebsite } from 'helpers/axiosInstances'
import { SetModel } from 'interfaces/set_model'
import { OperationDocumentModel } from 'interfaces/operation_document'
import React from 'react'
import OperationContract from './components/OperationContract'
import { ContractStallosModel } from 'interfaces/stallos/contract'
import { getOS, OS } from 'helpers/devices'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import {
  capitalizeFirstLetter,
  formatCNPJ,
  formatMoney,
  typeContract,
  typeOp
} from 'helpers/formats'
import saveAs from 'file-saver'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export type OperationQuery = (
  operation: OperationModel
) => Promise<OperationWithDocuments>

export const consumeById = async (operation: OperationModel) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  }
  const nextOperation = await axiosWebsite
    .get<OperationWithDocuments>(`/operation/${operation.id}`, config)
    .then((res) => res.data)

  nextOperation.documents = await axiosWebsite
    .get<{ sets: SetModel[] }>(`/set?operation_id=${nextOperation.id}`, config)
    .then((res) => res.data.sets)
    .then((sets) => {
      return sets.reduce((items, set) => {
        return [...items, ...(set.operation_documents || [])]
      }, [] as OperationDocumentModel[])
    })

  return nextOperation
}

export const consumeByOperationId = async (operation: OperationModel) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  }
  const nextOperation = await axiosWebsite
    .post<OperationWithDocuments[]>(
      `/operation/search`,
      {
        operation_number: Number(operation.operation_number),
        id_syscambio: Number(operation.user_syscambio)
      },
      config
    )
    .then((res) => res.data[0])

  return nextOperation
}

export const createOperationNumberConsumer = (
  url: string,
  additionals?: any
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  }
  return async (operation: OperationModel) => {
    const nextOperation = await axiosWebsite
      .post<OperationWithDocuments[]>(
        url,
        {
          ...additionals,
          operation_number: Number(operation.operation_number),
          id_syscambio: Number(operation.user_syscambio)
        },
        config
      )
      .then((res) => res.data[0])

    return nextOperation
  }
}

export type OperationWithDocuments = OperationModel & {
  documents: OperationDocumentModel[]
}

export class PdfExportHelper {
  constructor (private _doc: jsPDF) {}

  public async createAnalyticsRelatory (
    operations: OperationModel,
    consume: OperationQuery = consumeById
  ) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    }
    const contractInfos = await axiosWebsite
      .post<ContractStallosModel>(
        `/contrato`,
        {
          // operation_number: 511579,
          operation_number: operations.operation_number,
          id_syscambio: operations.user_syscambio
        },
        config
      )
      .then((res) => res.data)
      .then((res) => {
        // @ts-ignore
        if (res.flag && res.flag === 'noEvent') {
          throw new Error(
            // @ts-ignore
            res.message || res.messge || 'Operação sem Evento de Contrato'
          )
        }

        return res
      })

    const toPrint = this.createHardCopy(contractInfos, operations)
    pdfMake.createPdf(toPrint).open()
  }

  public async createOperationContract (operation: OperationModel) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    }
    const contractInfos = await axiosWebsite
      .post<ContractStallosModel>(
        `/contrato`,
        {
          // operation_number: 511579,
          operation_number: operation.operation_number,
          id_syscambio: operation.user_syscambio
        },
        config
      )
      .then((res) => res.data)
      .then((res) => {
        // @ts-ignore
        if (res.flag && res.flag === 'noEvent') {
          throw new Error(
            // @ts-ignore
            res.message || res.messge || 'Operação sem Evento de Contrato'
          )
        }

        return res
      })

    /*await this.reactRender(
      <OperationContract operation={operation} contractInfos={contractInfos} />,
      div,
      "Contrato de Operação"
    );*/

    const toPrint = this.createContract(contractInfos, operation)
    pdfMake.createPdf(toPrint).open()
  }

  public async createOperationContractMulti (operation: OperationModel[]) {
    const listFile: { name: string; file: any }[] = []
    const a: OperationModel[] = []

    a.push(operation[0])
    a.push(operation[1])
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    }
    for (const i of a) {
      const contractInfos = await axiosWebsite
        .post<ContractStallosModel>(
          `/contrato`,
          {
            operation_number: i.operation_number,
            id_syscambio: i.user_syscambio
          },
          config
        )
        .then((res) => res.data)
        .then((res) => {
          // @ts-ignore
          if (res.flag && res.flag === 'noEvent') {
            throw new Error(
              // @ts-ignore
              res.message || res.messge || 'Operação sem Evento de Contrato'
            )
          }

          return res
        })

      const toPrint = this.createContract(contractInfos, i)
      pdfMake.createPdf(toPrint).getBlob((blob) => {
        listFile.push({
          name: (i.bacen_number?.toString() ?? '') + '.pdf',
          file: blob
        })
      })
    }
    const zip = require('jszip')()

    for (let file = 0; file < listFile.length; file++) {
      zip.file(listFile[file].name, listFile[file].file)
    }
    zip.generateAsync({ type: 'blob' }).then((content: any) => {
      saveAs(content, 'example.zip')
    })
  }

  private createContract (
    contractInfos: ContractStallosModel,
    operation: OperationModel
  ): any {
    const cList = contractInfos.Clausulas.map((e) => {
      return [
        {
          text: `${e.Codigo}) ${e.Descricao}\n`,
          style: ['text'],
          border: [false, false, false, false]
        }
      ]
    })
    const dd = {
      header: [
        {
          image: 'bot_head',
          margin: [18, 10],
          fit: [180, 180]
        },
        {
          columns: [
            {
              text: 'Contrato de Câmbio',
              style: ['textB']
            }
          ],
          margin: [18, 0]
        },
        {
          table: {
            widths: [100, 100, '*', 70],
            body: [
              [
                {
                  text: `Tipo de Contrato\n\n${typeContract(
                    operation.product_type ?? ''
                  )}`,
                  style: ['text']
                },
                {
                  text: `Evento\n\n${capitalizeFirstLetter(
                    contractInfos.Evento
                  )}`,
                  style: ['text']
                },
                {
                  text: `Número do Contrato de Câmbio\n\n${contractInfos.NumeroContrato}`,
                  style: ['text']
                },
                {
                  text: `Data\n\n${
                    new Date(contractInfos.Data)
                      ?.toLocaleString('pt-BR', { timeZone: 'UTC' })
                      .split(',')[0]
                  }`,
                  style: ['text']
                }
              ]
            ]
          },
          margin: [18, 1]
        }
      ],
      footer: function (currentPage: any, pageCount: any) {
        return {
          text: `${currentPage.toString()} de ${pageCount}`,
          style: ['textFooter'],
          margin: [18, 0]
        }
      },
      content: [
        {
          stack: [
            {
              text: 'As partes a seguir denominadas, instituição financeira autorizada a operar no mercado de câmbio e cliente, contratam a presente operação de câmbio, nas condições aqui estipuladas e declaram que a mesma subordina-se às normas, condições e exigências legais e regulamentares aplicáveis à matéria',
              style: ['text'],
              margin: [0, 0, 0, 10]
            },
            {
              stack: [
                {
                  text: 'Instituição autorizada a operar no mercado de câmbio',
                  style: ['textSubTitle'],
                  margin: [0, 15, 0, 0]
                },
                {
                  table: {
                    widths: ['*', 160],
                    body: [
                      [
                        {
                          text: `Nome\n${contractInfos.IntituicaoIntermediadora?.Nome}`,
                          style: ['text']
                        },
                        {
                          text: `CNPJ\n${formatCNPJ(
                            contractInfos.IntituicaoIntermediadora.CNPJ
                          )}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          text: `Endereço\n${contractInfos.Instituicao.Endereco.Logradouro} ${contractInfos.Instituicao.Endereco.Numero}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: ['*', 80],
                    body: [
                      [
                        {
                          text: `Cidade\n${contractInfos.Instituicao.Endereco.Cidade}`,
                          style: ['text']
                        },
                        {
                          text: `UF\n${contractInfos.Instituicao.Endereco.Uf}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                }
              ]
            },

            {
              stack: [
                {
                  text: 'Cliente',
                  style: ['textSubTitle'],
                  margin: [0, 15, 0, 0]
                },
                {
                  table: {
                    widths: ['*', 160],
                    body: [
                      [
                        {
                          text: `Nome\n${contractInfos.Cliente.Nome}`,
                          style: ['text']
                        },
                        {
                          text: `CNPJ/CPF/Iden.Estrang.\n${formatCNPJ(
                            contractInfos.Cliente.Documento
                          )}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          text: `Endereço\n${contractInfos.Cliente.Endereco}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: ['*', 80],
                    body: [
                      [
                        {
                          text: `Cidade\n${contractInfos.Cliente.Cidade}`,
                          style: ['text']
                        },
                        {
                          text: `UF\n${contractInfos.Cliente.Estado}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                }
              ]
            },

            {
              stack: [
                {
                  text: 'Instituição Intermediadora',
                  style: ['textSubTitle'],
                  margin: [0, 15, 0, 0]
                },
                {
                  table: {
                    widths: ['*', 160],
                    body: [
                      [
                        {
                          text: 'Nome\nDASCAM CORRETORA DE CAMBIO LTDA',
                          style: ['text']
                        },
                        { text: 'CNPJ\n65.645.137/0001-49', style: ['text'] }
                      ]
                    ]
                  }
                }
              ]
            },

            {
              stack: [
                {
                  text: 'Dados da Operação',
                  style: ['textSubTitle'],
                  margin: [0, 15, 0, 0]
                },
                {
                  table: {
                    widths: [120, '*', 100],
                    body: [
                      [
                        {
                          text: `Código Moeda\n\n${contractInfos.DadosOperacao.CodigoIso}\n `,
                          style: ['text']
                        },
                        {
                          text: `Valor em moeda estrangeira\n\n${contractInfos.DadosOperacao.ValorME.Quantidade.toLocaleString(
                            'pt-br',
                            {
                              minimumFractionDigits: 2
                            }
                          )} (${
                            contractInfos.DadosOperacao.ValorME.Descricao
                          })\n `,
                          style: ['text'],
                          colSpan: 2
                        },
                        {}
                      ],
                      [
                        {
                          text: `Taxa Cambial\n\n${contractInfos.DadosOperacao.TaxaCambial.toLocaleString(
                            'pt-br',
                            {
                              minimumFractionDigits: 10
                            }
                          )}\n `,
                          style: ['text']
                        },
                        {
                          text: `Valor em moeda nacional\n\n${contractInfos.DadosOperacao.ValorReais.Quantidade.toLocaleString(
                            'pt-br',
                            {
                              minimumFractionDigits: 2
                            }
                          )} (${
                            contractInfos.DadosOperacao.ValorReais.Descricao
                          })\n `,
                          style: ['text'],
                          colSpan: 2
                        },
                        {}
                      ],
                      [
                        {
                          text: `Valor Efetivo Total(VET)\n${contractInfos.DadosOperacao.Vet.toLocaleString(
                            'pt-br',
                            {
                              minimumFractionDigits: 10
                            }
                          )}`,
                          style: ['text']
                        },
                        {
                          text: `Descrição da forma da Entrega da moeda estrangeira\n${contractInfos.DadosOperacao.FormaEntregaME.Codigo} - ${contractInfos.DadosOperacao.FormaEntregaME.Descricao}`,
                          style: ['text']
                        },
                        {
                          text: `Liquidação até\n${
                            new Date(contractInfos.DadosOperacao.DataLiquidacao)
                              .toLocaleString('pt-BR', { timeZone: 'UTC' })
                              .split(',')[0]
                          }`,
                          style: ['text']
                        }
                      ],
                      [
                        {
                          text: `Código natureza\n${contractInfos.DadosOperacao.Natureza.Codigo}`,
                          style: ['text']
                        },
                        {
                          text: `Descrição da Natureza do Fato\n${contractInfos.DadosOperacao.Natureza.Descricao}`,
                          style: ['text'],
                          colSpan: 2
                        },
                        {}
                      ],
                      [
                        {
                          text: `Pagador/Recebedor no exterior\n${contractInfos.DadosOperacao.PagadorRecebedor?.Nome}`,
                          style: ['text'],
                          colSpan: 3
                        },
                        {},
                        {}
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: [220, '*'],
                    body: [
                      [
                        {
                          text: `País do Pagador ou Recebedor no Exterior\n${contractInfos.DadosOperacao.PagadorRecebedor.Pais}`,
                          style: ['text']
                        },
                        {
                          text: `Código relação de vínculo entre cliente e pagador recebedor\n${contractInfos.DadosOperacao.PagadorRecebedor.RelacaoVinculo.Codigo} - ${contractInfos.DadosOperacao.PagadorRecebedor.RelacaoVinculo.Descricao}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                },
                {
                  table: {
                    widths: ['*', 120],
                    body: [
                      [
                        {
                          text: `Percentual de adiantamento sobre o contrato de câmbio\n${contractInfos.DadosOperacao.PercentualAdiantamento}%`,
                          style: ['text']
                        },
                        {
                          text: `RDE\n${contractInfos.DadosOperacao.RDE}`,
                          style: ['text']
                        }
                      ]
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          stack: [
            {
              stack: [
                {
                  text: 'Outras especificações',
                  style: ['textSubTitle'],
                  margin: [0, 0, 0, 0]
                },
                {
                  canvas: [
                    {
                      type: 'line',
                      x1: 0,
                      y1: 3,
                      x2: 560,
                      y2: 3,
                      lineWidth: 1.5
                    }
                  ]
                },
                {
                  text: `${contractInfos.OutrasEspecificacoes}`,
                  style: ['text'],
                  margin: [0, 3, 0, 10]
                }
              ]
            },
            {
              stack: [
                {
                  margin: [0, 35, 0, 0],
                  table: {
                    headerRows: 1,
                    body: [
                      [
                        {
                          text: 'Cláusulas Contratuais',
                          style: 'textSubTitle',
                          border: [false, false, false, true]
                        }
                      ],
                      ...cList
                    ]
                  }
                }
              ]
            }
          ],
          pageBreak: 'before'
        },
        {
          stack: [
            {
              text: 'Informações de Recebimento/Pagamento',
              style: ['textSubTitle'],
              margin: [0, 0, 0, 5]
            },
            {
              canvas: [
                { type: 'line', x1: 0, y1: 3, x2: 560, y2: 3, lineWidth: 1.5 }
              ]
            },
            {
              margin: [0, 3, 0, 0],
              table: {
                widths: [110, 50, '*', 50, 70],
                body: [
                  [
                    {
                      text: ' \nCanal Bancário em Moeda Nacional',
                      style: ['textBold'],
                      colSpan: 5
                    },
                    {},
                    {},
                    {},
                    {}
                  ],
                  [
                    {
                      text: `Forma de Entrega\n${contractInfos.InformacoesRecebimento.FormaEntrega.Codigo} - ${contractInfos.InformacoesRecebimento.FormaEntrega.Descricao}`,
                      style: ['text']
                    },
                    {
                      text: `Data\n${
                        contractInfos.InformacoesRecebimento.Data
                          ? new Date(contractInfos.InformacoesRecebimento.Data)
                              ?.toLocaleString('pt-BR', { timeZone: 'UTC' })
                              .split(',')[0]
                          : ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Banco\n${contractInfos.InformacoesRecebimento.Banco}`,
                      style: ['text']
                    },
                    {
                      text: `Agência\n${contractInfos.InformacoesRecebimento.Agencia}`,
                      style: ['text']
                    },
                    {
                      text: `Conta\n${contractInfos.InformacoesRecebimento.Conta}`,
                      style: ['text']
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 8, 0, 0],
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                    {
                      text: ' \nCanal Bancário em Moeda Estrangeira',
                      style: ['textBold'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ],
                  [
                    {
                      text: `Código Swift Banco Beneficiário\n\n${contractInfos.CanalBancarioMe.Beneficiario.Swift}`,
                      style: ['text']
                    },
                    {
                      text: `Código ABA Banco Beneficiário\n\n${contractInfos.CanalBancarioMe.Beneficiario.Aba}`,
                      style: ['text']
                    },
                    {
                      text: `Código CHIPS Banco Beneficiário\n\n${contractInfos.CanalBancarioMe.Beneficiario.CHIPS}`,
                      style: ['text']
                    }
                  ],
                  [
                    {
                      text: `Nome do Banco Beneficiário\n\n${contractInfos.CanalBancarioMe.Beneficiario.NomeBanco}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ],
                  [
                    {
                      text: `Conta no Exterior do Beneficiário /IBAN\n\n${contractInfos.CanalBancarioMe.Beneficiario.IBAN}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ]
                ]
              }
            },
            {
              margin: [0, 8, 0, 0],
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                    {
                      text: `Código Swift Banco Intermediário\n\n${contractInfos.CanalBancarioMe.Intermediario.Swift}`,
                      style: ['text']
                    },
                    {
                      text: `Código ABA Banco Intermediário\n\n${contractInfos.CanalBancarioMe.Intermediario.Aba}`,
                      style: ['text']
                    },
                    {
                      text: `Código CHIPS Banco Intermediário\n\n${contractInfos.CanalBancarioMe.Intermediario.CHIPS}`,
                      style: ['text']
                    }
                  ],
                  [
                    {
                      text: `Nome do Banco Intermediário\n\n${contractInfos.CanalBancarioMe.Intermediario.NomeBanco}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ],
                  [
                    {
                      text: `Conta no Exterior do Intermediário /IBAN\n\n${contractInfos.CanalBancarioMe.Intermediario.IBAN}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ]
                ]
              }
            }
          ],
          pageBreak: 'before'
        },
        {
          stack: [
            {
              text: `O cliente declara ter pleno conhecimento do texto constante do respectivo contrato de câmbio, do artigo 23 da Lei 4.131, de 03.09.1962, e em especial dos seus §§2o e 3o, transcritos neste documento, bem como do Regulamento do Mercado de Câmbio e Capitais internacionais, que regem a presente operação.
              
              Artigo 23 da Lei 4.131, §§ 2o e 3o com a redação dada pelo artigo 72 da Lei 9.069, de 29.06.1995:
              
              "§2o Constitui infração imputável ao estabelecimento bancário, ao corretor e ao cliente, punível com multa de 50 (cinquenta) a 300% (trezentos por cento) do valor da operação para cada um dos infratores, a declaração de falsa identidade no formulário que, em número de vias e segundo o modelo determinado pelo Banco Central do Brasil, será exigido em cada operação, assinado pelo cliente e visado pelo estabelecimento bancário e pelo corretor que nela intervierem.
              
              §3o - Constitui infração, de responsabilidade exclusiva do cliente, punível com multa de 5 (cinco) a 100% (cem por cento) do valor da operação, a declaração de informações falsas no formulário a que se refere o §2o."`,
              style: ['text'],
              margin: [0, 0, 0, 70]
            },
            {
              text: 'Meios de Comunicação (SAC, Ouvidoria, Canal de Denúncia, etc):',
              style: ['text'],
              margin: [0, 0, 0, 20]
            },
            {
              margin: [0, 3, 0, 0],
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text: ` \nAssinaturas: NOME, CPF E ASSINATURA\n\n\n\n\n\n\n\n\nInstituição autorizada a operar no mercado de câmbio: ${contractInfos.IntituicaoIntermediadora?.Nome}`,
                      style: ['textBold']
                    }
                  ],
                  [
                    {
                      text: ` \nAssinaturas: NOME, CPF E ASSINATURA\n\n\n\n\n\n\n\n\n\nCliente: ${contractInfos.Cliente.Nome}`,
                      style: ['textBold']
                    }
                  ],
                  [
                    {
                      text: ` \nAssinaturas: NOME, CPF E ASSINATURA\n\n\n\n \u00a0                     ${contractInfos.Assinaturas[0]?.Nome}\n \u00a0                          ${contractInfos.Assinaturas[0]?.Documento}\n\n\nInstituição Intermediadora: DASCAM CORRETORA DE CAMBIO LTDA`,
                      style: ['textBold']
                    }
                  ]
                ]
              }
            }
          ],
          pageBreak: 'before'
        }
      ],
      images: {
        bot_head:
          'data:image/png;base64,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'
      },
      pageSize: 'A4',
      pageMargins: [18, 140, 18, 15],
      styles: {
        header: {
          fontSize: 22,
          bold: true
        },
        textSubTitle: {
          bold: true,
          fontSize: 12
        },
        textB: {
          bold: true,
          alignment: 'right',
          fontSize: 11
        },
        text: {
          fontSize: 9
        },
        textBold: {
          fontSize: 9,
          bold: true
        },
        textFooter: {
          fontSize: 9,
          alignment: 'right'
        }
      }
    }
    return dd
  }

  private createHardCopy (
    contractInfos: ContractStallosModel,
    operations: OperationModel
  ): any {
    return {
      header: [
        {
          image: 'bot_head',
          margin: [18, 5],
          fit: [180, 180]
        },
        {
          columns: [
            {
              text: 'Relatório de Conferência - Operação',
              style: ['textCenter']
            }
          ]
        }
      ],
      content: [
        {
          stack: [
            {
              table: {
                widths: ['*', '*', '*', '*', '*', '*'],
                body: [
                  [
                    {
                      text: `Sequência\n${operations.operation_number ?? ''}`,
                      style: ['text']
                    },
                    {
                      text: `BACEN\n${contractInfos.NumeroContrato ?? ''}`,
                      style: ['text']
                    },
                    {
                      text: `Operação\n${typeContract(
                        operations.product_type ?? ''
                      )}`,
                      style: ['text']
                    },
                    {
                      text: `Produto\n${operations.product_type ?? ''}`,
                      style: ['text']
                    },
                    {
                      text: `Fechamento\n${
                        new Date(contractInfos.Data)
                          .toLocaleString('pt-BR', { timeZone: 'UTC' })
                          .split(',')[0]
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Usuário\n${operations.operator ?? ''}`,
                      style: ['text']
                    }
                  ]
                ]
              }
            },
            {
              table: {
                widths: [330, '*', '*'],
                body: [
                  [
                    {
                      text: `Instituição Financeira\n${
                        contractInfos.IntituicaoIntermediadora.Nome ?? ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `CNPJ\n${formatCNPJ(
                        contractInfos.IntituicaoIntermediadora.CNPJ ?? ''
                      )}`,
                      style: ['text']
                    },
                    { text: `Código\n${operations.inst_id}`, style: ['text'] }
                  ],
                  [
                    {
                      text: `Endereço\n${
                        contractInfos.Instituicao.Endereco.Logradouro ?? ''
                      } ${contractInfos.Instituicao.Endereco.Numero ?? ''}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ]
                ]
              },
              margin: [0, 1]
            },
            {
              table: {
                widths: [330, '*', '*'],
                body: [
                  [
                    {
                      text: `Cliente\n${contractInfos.Cliente.Nome ?? ''}`,
                      style: ['text']
                    },
                    {
                      text: `CNPJ / CPF\n${formatCNPJ(
                        contractInfos.Cliente.Documento ?? ''
                      )}`,
                      style: ['text']
                    },
                    {
                      text: `Código\n${operations.user_syscambio ?? ''}`,
                      style: ['text']
                    }
                  ],
                  [
                    {
                      text: `Endereço\n${contractInfos.Cliente.Endereco ?? ''}`,
                      style: ['text'],
                      colSpan: 3
                    },
                    {},
                    {}
                  ]
                ]
              },
              margin: [0, 1]
            },
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text: `Operador de Câmbio\n${operations.operator ?? ''}`,
                      style: ['text']
                    }
                  ]
                ]
              },
              margin: [0, 1]
            },
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text: `Natureza de operação\n${
                        contractInfos.DadosOperacao.Natureza.Codigo ?? ''
                      } - ${
                        contractInfos.DadosOperacao.Natureza.Descricao ?? ''
                      }`,
                      style: ['text']
                    }
                  ]
                ]
              },
              margin: [0, 1]
            },
            {
              table: {
                widths: [200, 130, '*', '*'],
                body: [
                  [
                    {
                      text: `Moeda estrangeira\n${
                        contractInfos.DadosOperacao.CodigoIso ?? ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Forma de entrega\n${
                        contractInfos.DadosOperacao.FormaEntregaME.Codigo ?? ''
                      } - ${
                        contractInfos.DadosOperacao.FormaEntregaME.Descricao ??
                        ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Dias entrega\n ${
                        contractInfos.InformacoesRecebimento.Data
                          ? (
                              (new Date(contractInfos.Data).getTime() -
                                new Date(
                                  contractInfos.InformacoesRecebimento.Data
                                ).getTime()) /
                              (1000 * 3600 * 24)
                            ).toFixed(0)
                          : 0
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Data entrega\n${
                        contractInfos.InformacoesRecebimento.Data
                          ? new Date(contractInfos.InformacoesRecebimento.Data)
                              .toLocaleString('pt-BR', { timeZone: 'UTC' })
                              .split(',')[0]
                          : ''
                      }`,
                      style: ['text']
                    }
                  ]
                ]
              },
              margin: [0, 1]
            },
            {
              table: {
                widths: ['*', '*', '*', '*', '*', 60],
                body: [
                  [
                    {
                      text: `Liq. BACEN\n${operations.bacen_days} ${
                        operations.bacen_closure
                          ? new Date(operations.bacen_closure)
                              .toLocaleString('pt-BR', { timeZone: 'UTC' })
                              .split(',')[0]
                          : ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Liq. Reais\n${operations.reais_days} ${
                        operations.reais_closure
                          ? new Date(operations.reais_closure)
                              .toLocaleString('pt-BR', { timeZone: 'UTC' })
                              .split(',')[0]
                          : ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Forma de pagamento\n${
                        contractInfos.InformacoesRecebimento.FormaEntrega
                          .Descricao ?? ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Agência\n${
                        contractInfos.InformacoesRecebimento.Agencia ?? ''
                      }`,
                      style: ['text']
                    },
                    {
                      text: `Conta Corrente\n${
                        contractInfos.InformacoesRecebimento.Conta ?? ''
                      }`,
                      style: ['text']
                    },
                    { text: `ISPB\n${operations.ispb ?? ''}`, style: ['text'] }
                  ]
                ]
              }
            },
            {
              columns: [
                {
                  width: 175,
                  stack: [
                    {
                      table: {
                        widths: [60, '*'],
                        heights: [70, 10],
                        body: [
                          [
                            {
                              border: [true, true, false, true],
                              text: `Valor moeda:\n
                        Taxa cambial:\n
                        Valor reais:\n
                        Taxa VET:`,
                              style: ['textR']
                            },
                            {
                              border: [false, true, true, true],
                              text: `${contractInfos.DadosOperacao.ValorME.Quantidade.toLocaleString(
                                'pt-br',
                                { minimumFractionDigits: 2 }
                              )}\n
                              ${contractInfos.DadosOperacao.TaxaCambial.toLocaleString(
                                'pt-br',
                                { minimumFractionDigits: 10 }
                              )}\n
                        ${contractInfos.DadosOperacao.ValorReais.Quantidade.toLocaleString(
                          'pt-br',
                          { minimumFractionDigits: 2 }
                        )}\n
                        ${contractInfos.DadosOperacao.Vet.toLocaleString(
                          'pt-br',
                          { minimumFractionDigits: 10 }
                        )}`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, true, false, true],
                              text: `Corretagem:`,
                              style: ['textR']
                            },
                            {
                              border: [false, true, true, true],
                              text: `${contractInfos.DadosOperacao.ValorReais.Quantidade.toLocaleString(
                                'pt-br',
                                { minimumFractionDigits: 2 }
                              )}`,
                              style: ['textR']
                            }
                          ]
                        ]
                      },
                      margin: [0, 2, 2, 0]
                    },
                    {
                      table: {
                        widths: [50, '*', '*'],
                        heights: ['*', '*', '*', 28],
                        body: [
                          [
                            {
                              border: [true, true, true, false],
                              text: `Valores repassados ao cliente:`,
                              style: ['text'],
                              colSpan: 3
                            },
                            {},
                            {}
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `IOF:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'IOF' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.PercImposto?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }%`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'IOF' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `Tarifa:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'TAFIFA' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            { border: [true, false, false, false], text: '' },
                            { border: [false, false, false, false], text: '' },
                            { border: [false, false, true, false], text: '' }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `CIDE:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'CIDE' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `PIS:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'PIS' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `COFINS:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'COFINS' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `CSLL:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'CSLL' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `ISS:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'ISS' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, false, false, false],
                              text: `IR:`,
                              style: ['textR']
                            },
                            {
                              border: [false, false, false, false],
                              text: ``,
                              style: ['textR']
                            },
                            {
                              border: [false, false, true, false],
                              text: `${
                                operations.imp
                                  ?.filter(
                                    (e) =>
                                      e.Tipo === 'IR' &&
                                      e.RecolhimentoPorConta === 'CLIENTE'
                                  )[0]
                                  ?.Valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2
                                  }) ?? '0,00'
                              }`,
                              style: ['textR']
                            }
                          ],
                          [
                            {
                              border: [true, true, false, true],
                              text: `Total R$:`,
                              style: ['textR']
                            },
                            {
                              border: [false, true, true, true],
                              text: `${contractInfos.DadosOperacao.ValorReais.Quantidade.toLocaleString(
                                'pt-br',
                                { minimumFractionDigits: 2 }
                              )}`,
                              style: ['textR'],
                              colSpan: 2
                            },
                            {}
                          ]
                        ]
                      },
                      margin: [0, 2, 2, 0]
                    }
                  ]
                },
                {
                  width: '*',
                  table: {
                    widths: ['*'],
                    heights: [280],
                    body: [
                      [
                        {
                          text: `Pagador / Recebedor no exterior
                      ${contractInfos.DadosOperacao.PagadorRecebedor.Nome ?? ''}
                      País:${
                        contractInfos.DadosOperacao.PagadorRecebedor.Pais ?? ''
                      } ${operations.country_name ?? ''}
                      Relação de vínculo:${
                        contractInfos.DadosOperacao.PagadorRecebedor
                          .RelacaoVinculo.Codigo ?? ''
                      } - ${
                            contractInfos.DadosOperacao.PagadorRecebedor
                              .RelacaoVinculo.Descricao ?? ''
                          }

                      NIF:${
                        operations.beneficiary_nif ?? ''
                      }                                             Details of charge:${
                            operations.beneficiary_detail_charge ?? ''
                          } 
                      End.:${operations.beneficiary_address ?? ''}
                      Obs.:${operations.beneficiary_observacao ?? ''}

                      Nome do Banqueiro / Canal
                      ${
                        contractInfos.CanalBancarioMe.Beneficiario.NomeBanco ??
                        ''
                      }
                      SWIFT: ${
                        contractInfos.CanalBancarioMe.Beneficiario.Swift ?? ''
                      }                                            
                      ABA: ${
                        contractInfos.CanalBancarioMe.Beneficiario.Aba ?? ''
                      }
                      CHIPS: ${
                        contractInfos.CanalBancarioMe.Beneficiario.CHIPS ?? ''
                      } 
                      Conta: ${operations.bank_account ?? ''}
                      IBAN: ${operations.bank_iban ?? ''}
                      País: ${operations.bank_country ?? ''}
                      End.: ${operations.bank_address ?? ''}
                      
                      Intermediário:
                      ${
                        contractInfos.CanalBancarioMe.Intermediario.NomeBanco ??
                        ''
                      }
                      SWIFT: ${
                        contractInfos.CanalBancarioMe.Intermediario.Swift ?? ''
                      }                                            
                      ABA: ${
                        contractInfos.CanalBancarioMe.Intermediario.Aba ?? ''
                      }
                      CHIPS: ${
                        contractInfos.CanalBancarioMe.Intermediario.CHIPS ?? ''
                      } 
                      Conta: ${operations.intermediary_account ?? ''}
                      IBAN: ${operations.intermediary_iban ?? ''}
                      País: ${operations.intermediary_country ?? ''}
                      End.: ${operations.intermediary_account ?? ''}
                      `,
                          style: ['text']
                        }
                      ]
                    ]
                  },
                  margin: [0, 2, 2, 0]
                },
                {
                  width: 50,
                  table: {
                    heights: [280],
                    widths: ['*'],
                    body: [
                      [
                        {
                          text: `Cláusulas\n${contractInfos.Clausulas.map(
                            (e) => `${e.Codigo}\n`
                          )
                            .join(',')
                            .replaceAll(',', '')}`,
                          style: ['text']
                        }
                      ]
                    ]
                  },
                  margin: [0, 2, 0, 0]
                }
              ]
            },
            {
              text: 'Outras especificações:',
              margin: [0, 5],
              style: ['textSubTitle']
            },
            {
              text: `${contractInfos.OutrasEspecificacoes ?? ''}`,
              style: ['text']
            }
          ]
        }
      ],
      images: {
        bot_head:
          'data:image/png;base64,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'
      },
      pageSize: 'A4',
      pageMargins: [18, 85, 18, 15],
      styles: {
        header: {
          fontSize: 22,
          bold: true
        },
        textSubTitle: {
          bold: true,
          fontSize: 12
        },
        textCenter: {
          bold: true,
          alignment: 'center',
          fontSize: 12
        },
        textR: {
          alignment: 'right',
          fontSize: 9
        },
        text: {
          fontSize: 8
        },
        textFooter: {
          fontSize: 9,
          alignment: 'right'
        },
        textBold: {
          fontSize: 9,
          bold: true
        }
      }
    }
  }

  private async reactRender (
    el: React.ReactNode,
    div: HTMLDivElement,
    name: string
  ) {
    const operationalSystem = getOS()
    return new Promise<void>((resolve) => {
      ReactDOM.render(<>{el}</>, div, () => {
        setTimeout(() => {
          this._doc.setFont('helvetica')
          this._doc.html(div, {
            y: 0,
            x: 0,
            width: operationalSystem === OS.mac ? 210 : 210,
            windowWidth: 1000,
            callback (doc) {
              setTimeout(() => {
                doc.save(name)
                resolve()
              }, 500)
            }
          })
        }, 500)
      })
    })
  }

  private createDiv (props: Partial<CSSStyleDeclaration>) {
    const div = document.createElement('div')
    Object.assign(div.style, props)
    return div
  }
}
